/* eslint-disable */

export const handleValidation = (inputFields) =>{
    let fields = inputFields;
    let errors = {};
    let individualInputErrors = {}
    let formIsValid = true;
    //Name
    if (!fields["insuranceName"]) {
      formIsValid = false;
      errors["insuranceName"] = "Cannot be empty";
      individualInputErrors["insuranceName"] = true
    }

    if (!fields["insuranceType"]) {
        formIsValid = false;
        errors["insuranceType"] = "Cannot be empty";
        individualInputErrors["insuranceType"] = true
      }
    
    return {formIsValid, errors, individualInputErrors};
  }